import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { GasoilConsumptionPriceSource } from "__generated__/graphql";

const GasoilConsumptionPriceSourceSelect = ({ value, onChange }: Omit<SelectProps<GasoilConsumptionPriceSource, false>, "fetchOptions">) => {
	return (
		<Select
			value={value}
			onChange={onChange}
			fetchOptions={Object.values(GasoilConsumptionPriceSource)}
			getOptionLabel={option => intl.formatMessage({ id: `GASOIL_CONSUMPTION_PRICE_SOURCE_${option}` })}
		/>
	);
};

export default GasoilConsumptionPriceSourceSelect;
